import { getLocaleString as localize } from "utils/localization/locale";
import mapValues from "lodash/mapValues";

export const getDeductionListColumns = (getLocaleString = localize) => ({
  [getLocaleString("common.id", "ID")]: true,
  [getLocaleString("common.date", "Date")]: true,
  [getLocaleString("deduction.check_no", "Check No")]: true,
  [getLocaleString("common.customer", "Customer")]: true,
  [getLocaleString("common.reference", "Reference")]: true,
  [getLocaleString("common.amount", "Amount")]: true,
  [getLocaleString("deduction.reason", "Reason")]: true,
  [getLocaleString("deduction.sub_reason", "Sub Reason")]: true,
  [getLocaleString("common.invoice", "Invoice")]: true,
  [getLocaleString("common.invoice_date", "Invoice Date")]: true,
  [getLocaleString("common.type", "Type")]: true,
  [getLocaleString("common.status", "Status")]: true,
  [getLocaleString("deduction.outcome", "Outcome")]: true,
  [getLocaleString("deduction.class", "Class")]: true,
  [getLocaleString("deduction.account_manager", "Account Manager")]: true,
  [getLocaleString("deduction.custom_field_period", "Period")]: true,
  [getLocaleString("deduction.customer_po_number", "Customer PO No")]: true,
  [getLocaleString("deduction.ns_transaction_number", "NS Transaction No")]:
    true,
  [getLocaleString("deduction.additional_comment", "Additional Comment")]: true,
  [getLocaleString("common.actions", "Actions")]: true,
});

export const DEDUCTION_LIST_COLUMNS = getDeductionListColumns();

// Must match the headers expected by the deduction upload-csv API; do not localize.
export const DEDUCTION_CSV_TEMPLATE_HEADERS = [
  "Class",
  "Date",
  "Check No",
  "Customer",
  "Account Manager",
  "Reference",
  "Amount",
  "Reason",
  "Sub Reason",
  "Invoice",
  "Customer PO No",
  "Invoice Date",
  "Type",
  "Status",
  "Outcome",
  "NS Transaction No",
  "Additional Comment",
  "Period",
];

export const DEDUCTION_CSV_TEMPLATE_FILENAME = "deduction_upload_template.csv";

let i = 1;
export const initialDashboardDeductionColumnsOrder = mapValues(
  DEDUCTION_LIST_COLUMNS,
  () => i++
);

export const initialDeductionFilters = {
  page: 1,
  per_page: 20,
  status: "",
  type: "",
  reference: "",
  check_no: "",
  customer_po_number: "",
  amount_min: "",
  amount_max: "",
  from_date: "",
  to_date: "",
  client_customer_rel_id: "",
  invoice_source_id: "",
  deduction_class: "",
  account_manager: "",
};
